export default __webpack_public_path__ + "static/media/pic7.f58bc522.jpg";